export default function () {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2306_36766)">
                <path
                    d="M6 29.75C5.17157 29.75 4.5 29.0784 4.5 28.25V12.5C4.5 11.6716 5.17157 11 6 11H11.8636L14.0221 7.70234C14.2069 7.42008 14.5215 7.25 14.8588 7.25H21.1412C21.4785 7.25 21.7931 7.42008 21.9779 7.70234L24.1364 11H30C30.8284 11 31.5 11.6716 31.5 12.5V28.25C31.5 29.0784 30.8284 29.75 30 29.75H6Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="27" cy="15.125" r="1.125" fill="black" />
                <path
                    d="M18 25.25C21.1067 25.25 23.625 22.7317 23.625 19.625C23.625 16.5183 21.1067 14 18 14C14.8933 14 12.375 16.5183 12.375 19.625C12.375 22.7317 14.8933 25.25 18 25.25Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </g>
            <defs>
                <clipPath id="clip0_2306_36766">
                    <rect width="36" height="36" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
